var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-bpmn',{ref:"basicBpm",attrs:{"value":_vm.lcdata.relation,"register":_vm.BpmnRegister},on:{"back":_vm.back,"save":_vm.save},scopedSlots:_vm._u([{key:"PropertiesPanel",fn:function(data){return [_c('TaskForm',_vm._b({attrs:{"dataSoure":_vm.dataSoureObj}},'TaskForm',data,false))]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }